<template>
  <div>
    <div class="kk-subnav__footer">
      <div class="kk-subnav__footer-leftside">
        <div
          v-for="item in items"
          :key="item.id"
          :data-test-id="item.testId"
          class="kk-subnav__footer-leftside-item"
          @click="item.func()"
        >
          <custom-icon class="kk-subnav__footer-icon" :class-name="item.icon" />
          <div>{{ item.title }}</div>
        </div>
      </div>
      <div
        v-if="!trashDisabled"
        data-test-id="footer-trash"
        class="kk-subnav__footer-rightside"
        @click="showTrashItems = !showTrashItems"
      >
        <custom-icon class="kk-subnav__footer-icon" :class-name="`${showTrashItems ? 'icon-x' : 'icon-trash'}`" />
      </div>
    </div>
    <trash v-if="showTrashItems" :trash-items="trashItems" :store="store"></trash>
  </div>
</template>

<script>
import CustomIcon from "../../commons/CustomIcon.vue";
import Trash from "./Trash.vue";

export default {
  components: { Trash, CustomIcon },
  props: ["items", "store", "trashDisabled"],

  computed: {
    computedclassName() {
      return this.trashItems ? "" : "";
    },
    trashItems() {
      return this.$store.getters[`${this.store}/getTrashItems`]();
    },
    showTrashItems: {
      get() {
        if (!this.store) return false;
        return this.$store.state[this.store].showTrash;
      },
      set(newValue) {
        if (!this.store) return false;
        return this.$store.dispatch(`${this.store}/toggleTrash`, newValue);
      },
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";
.kk-subnav {
  &__footer {
    padding: 0 0 0 20px;
    height: 50px;
    border-top: 3px solid #d7d7d7;
    color: @kk-color-primary-blue;
    display: flex;
    font-size: 18px;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    &-icon {
      font-size: 22px;
      color: #15bef0 !important;
    }
    &-leftside {
      display: flex;
      flex: 1;
      padding-right: 0.5rem;
      gap: 0.8rem;
      align-items: center;
      &-item {
        font-size: 8px;
        text-align: center;
        cursor: pointer;
        &:hover {
          color: @kk-color-light-blue;
        }
      }
    }
    &-rightside {
      height: 100%;
      border-left: 3px solid #d7d7d7;
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgb(145, 174, 231);
      cursor: pointer;
      &:hover {
        color: rgb(21, 190, 240);
      }
    }
  }
}
</style>
